import Env from '../../base/env'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
gsap.registerPlugin(ScrollToPlugin);

export default class Sms
{
  constructor(view)
  {
    this.view = view
    this.$loading = this.view.querySelector('.jsLoading')
    // this.$cache = this.view.querySelector('.jsCache')
    // this.$btnReadMore = this.view.querySelector('.jsReadMore')
    this.$collection = this.view.querySelector('.jsCollection')
    this.$items = this.view.querySelectorAll('.jsItem')
    this.$itemsIntro = []
    this.$itemsTrigger = []
    this.forceScroll = false;
    this.setup()
  }

  captureIntroItems()
  {
    const getHeightWrapper = this.$collection.getBoundingClientRect().height
    const ratioHeight = (Env.mobileCSS == true)?1:1;
    for(let $item of this.$items) {
      const posY = $item.offsetTop
      if(posY < getHeightWrapper * ratioHeight) {
        this.$itemsIntro.push($item)
      } else {
        this.$itemsTrigger.push($item)
      }
    }
  }

  events()
  {
    // this.$btnReadMore.addEventListener('click',()=>{
    //   this.scroll()
    // })

    this.$collection.addEventListener('scroll',()=>{
      if(this.forceScroll ==  false) {
        this.forceScroll = true
        // gsap.to(this.$btnReadMore , { autoAlpha: 0, ease: 'cubic.out' , duration:1 })
        // gsap.to(this.$loading , { autoAlpha: 0, ease: 'cubic.out' , duration:.5 })
        // gsap.to(this.$cache , { autoAlpha: 0, ease: 'cubic.out' , duration:.5 })
      }
    })
  }

  intro()
  {
    const tl = gsap.timeline()

    tl.add([
      gsap.fromTo(this.$itemsIntro, { y : 10 }, { y : 0 , autoAlpha : 1 , ease : 'cubic.inOut' , duration : 1 , stagger : .35 }),
    ])
    tl.add([
      // gsap.fromTo(this.$loading , { y : 10 , autoAlpha : 0 } , { autoAlpha : 1, y: 0 , duration : 1 , ease : 'power3.out'} ),
      // gsap.fromTo(this.$btnReadMore , { y : 10 , autoAlpha : 0 } , { autoAlpha : 1, y: 0 , duration : 1 , ease : 'power3.out'} ),
    ])
    tl.add(()=>{
      this.$collection.classList.add('is-enabled')
    })

  }

  reveal()
  {
    for(let $item of this.$itemsTrigger) {
      gsap.fromTo(
        $item,
        { y : 5 },
        { y : 0 , autoAlpha : 1 , duration: 1, ease: 'cubic.inOut',
          scrollTrigger: {
            scroller:this.$collection,
            trigger : $item ,
            start: 'top bottom-=120',
        }}
      )
    }
  }

  scroll()
  {
    this.forceScroll = true
    // gsap.to(this.$btnReadMore , { autoAlpha: 0, ease: 'cubic.out' , duration:1 , onComplete:()=>{
    //   this.$btnReadMore.classList.add('tw-hidden')
    // } })
    // gsap.to(this.$loading , { autoAlpha: 0, ease: 'cubic.out' , duration:.5 })
    // gsap.to(this.$cache , { autoAlpha: 0, ease: 'cubic.out' , duration:.5 })
    gsap.to(this.$collection , { scrollTo : { y : 'max' }, ease: 'linear' , duration:30 })
  }

  setup()
  {
    this.captureIntroItems()
    this.events()
    this.intro()
    this.reveal()

  }
}
